<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        การจัดการเวลา Unlock
      </span>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="handleAddTimezoneForm">
        <v-icon small left>mdi-plus</v-icon>เพิ่มเวลา Unlock
      </v-btn>
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="timezones"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.view="{ item }">
        <button
          type="button"
          class="btn-text"
          @click.stop="handleClickView(item)"
        >
          ดูแผนภาพ
        </button>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogView" width="1280">
      <v-card>
        <v-card-title class="body-2 grey lighten-2 d-flex">
          <div class="flex-grow-1 d-flex">
            <div style="width: 280px">
              <div style="color: gray">รหัส Unlock :</div>
              <div class="body-2">{{ timezoneView.timezone_code }}</div>
            </div>
            <div>
              <div style="color: gray">คำอธิบาย (ไทย)</div>
              <div class="body-2">{{ timezoneView.title_th }}</div>
            </div>
          </div>
          <div>
            <v-btn icon @click="dialogView = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="py-6">
          <TimezoneTable :timezoneDetail="timezoneView.timezone_detail" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <UnlockForm
      :formShow="timezoneFormShow"
      :formAction="timezoneFormAction"
      :timezone="timezone"
      :timezoneInit="timezoneInit"
      @isTimezoneDataChange="handleTimezoneFormDataChange"
      @formActionCompleted="handleTimezoneFormActionCompleted"
      @onReset="handleTimezoneFormReset"
      @onChangeDayCopy="handleOnChangeDayCopy"
      @onDayCopyCancel="handleOnDayCopyCancel"
      @onDayCopy="handleOnDayCopy"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="timezoneFormShow && timezoneFormAction === 'add'"
      z-index="0"
    ></v-overlay>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TimezoneTable from '@/components/TimezoneTable.vue'
import UnlockForm from '@/views/unlock/UnlockForm.vue'

export default {
  components: {
    UnlockForm,
    ConfirmDialog,
    TimezoneTable,
  },
  data() {
    return {
      timezoneView: {
        timezone_code: '',
        title_th: '',
        timezone_detail: [],
      },
      sortBy: ['timezone_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      timezoneFormShow: false,
      timezoneFormAction: '',
      initTimezoneData: {
        timezone_code: '',
        title_th: '',
        title_en: '',
        timezone_detail: Array.from(
          [
            { day_type_id: 1, title_short_th: 'อา.' },
            { day_type_id: 2, title_short_th: 'จ.' },
            { day_type_id: 3, title_short_th: 'อ.' },
            { day_type_id: 4, title_short_th: 'พ.' },
            { day_type_id: 5, title_short_th: 'พฤ.' },
            { day_type_id: 6, title_short_th: 'ศ.' },
            { day_type_id: 7, title_short_th: 'ส.' },
            { day_type_id: 8, title_short_th: 'หยุด' },
          ],
          ({ day_type_id, title_short_th }) => ({
            day_type: {
              day_type_id,
              title_short_th,
            },
            timezone_time_period: Array.from([1, 2, 3, 4, 5], (item) => ({
              time_period_start: null,
              time_period_end: null,
              display_order: item,
            })),
          })
        ),
      },
      timezone: {
        timezone_code: '',
        title_th: '',
        title_en: '',
        timezone_detail: Array.from(
          [
            { day_type_id: 1, title_short_th: 'อา.' },
            { day_type_id: 2, title_short_th: 'จ.' },
            { day_type_id: 3, title_short_th: 'อ.' },
            { day_type_id: 4, title_short_th: 'พ.' },
            { day_type_id: 5, title_short_th: 'พฤ.' },
            { day_type_id: 6, title_short_th: 'ศ.' },
            { day_type_id: 7, title_short_th: 'ส.' },
            { day_type_id: 8, title_short_th: 'หยุด' },
          ],
          ({ day_type_id, title_short_th }) => ({
            day_type: {
              day_type_id,
              title_short_th,
            },
            timezone_time_period: Array.from([1, 2, 3, 4, 5], (item) => ({
              time_period_start: null,
              time_period_end: null,
              display_order: item,
            })),
          })
        ),
      },
      timezoneInit: {
        timezone_code: '',
        title_th: '',
        title_en: '',
        timezone_detail: Array.from(
          [
            { day_type_id: 1, title_short_th: 'อา.' },
            { day_type_id: 2, title_short_th: 'จ.' },
            { day_type_id: 3, title_short_th: 'อ.' },
            { day_type_id: 4, title_short_th: 'พ.' },
            { day_type_id: 5, title_short_th: 'พฤ.' },
            { day_type_id: 6, title_short_th: 'ศ.' },
            { day_type_id: 7, title_short_th: 'ส.' },
            { day_type_id: 8, title_short_th: 'หยุด' },
          ],
          ({ day_type_id, title_short_th }) => ({
            day_type: {
              day_type_id,
              title_short_th,
            },
            timezone_time_period: Array.from([1, 2, 3, 4, 5], (item) => ({
              time_period_start: null,
              time_period_end: null,
              display_order: item,
            })),
          })
        ),
      },
      isTimezoneDataChange: false,
      timeout: null,
      dialogView: false,
    }
  },
  computed: {
    headers() {
      return [
        { text: 'รหัสเวลา Unlock', align: 'start', value: 'timezone_code' },
        { text: 'คำอธิบาย (ไทย)', align: 'start', value: 'title_th' },
        { text: 'ดูแผนภาพ', align: 'start', value: 'view' },
      ]
    },
    timezones() {
      return this.$store.state.timezone.timezones
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การจัดการ Unlock',
        disabled: true,
      },
    ])

    this.loading = true
    const { company_uuid } = this.$store.state.authentication.company

    this.fetchTimezones({ company_uuid })
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchTimezones: 'timezone/fetchTimezones',
    }),
    handleClickView(timezoneSelected) {
      this.dialogView = true
      this.timezoneView = {
        timezone_code: timezoneSelected.timezone_code,
        title_th: timezoneSelected.title_th,
        timezone_detail: timezoneSelected.timezone_detail.map((timezone) => {
          return {
            timezone_detail_uuid: timezone.timezone_detail_uuid,
            timezone_time_period: timezone.timezone_time_period.map((item) => {
              if (item.time_period_start && item.time_period_end) {
                return {
                  time_period_start: item.time_period_start,
                  time_period_end: item.time_period_end,
                  start:
                    Number(item.time_period_start.split(':')[0]) * 44 +
                    (Number(item.time_period_start.split(':')[1]) / 60) * 44,
                  end:
                    (Number(item.time_period_end.split(':')[0]) -
                      Number(item.time_period_start.split(':')[0])) *
                      44 +
                    Number(item.time_period_end.split(':')[1] / 60) * 44 -
                    Number(item.time_period_start.split(':')[1] / 60) * 44,
                }
              }
            }),
          }
        }),
      }
    },
    handleOnChangeDayCopy(timezone) {
      this.timezone = JSON.parse(JSON.stringify(timezone))
    },
    handleOnDayCopyCancel(timezone) {
      this.timezone = JSON.parse(JSON.stringify(timezone))
    },
    handleOnDayCopy(timezone) {
      this.timezone = JSON.parse(JSON.stringify(timezone))
    },
    classRowSelected(row) {
      if (this.timezone.timezone_uuid === row.timezone_uuid) {
        return 'row-selected'
      }
    },
    setDataRowSelected(row) {
      if (this.timezone.timezone_uuid === row.timezone_uuid) {
        this.timezoneFormShow = false
        this.timezoneFormAction = ''
        this.timezone = JSON.parse(JSON.stringify(this.initTimezoneData))
        this.timezoneInit = JSON.parse(JSON.stringify(this.initTimezoneData))
      } else {
        this.timezoneFormShow = true
        this.timezoneFormAction = 'edit'
        this.timezone = JSON.parse(JSON.stringify(row))
        this.timezoneInit = JSON.parse(JSON.stringify(row))
      }
    },
    handleRowSelected(row) {
      if (this.isTimezoneDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddTimezoneForm() {
      this.timezoneFormShow = true
      this.timezoneFormAction = 'add'
      this.timezone = JSON.parse(JSON.stringify(this.initTimezoneData))
      this.timezoneInit = JSON.parse(JSON.stringify(this.initTimezoneData))
    },
    handleTimezoneFormDataChange(value) {
      this.isTimezoneDataChange = value
    },
    handleTimezoneFormReset(formAction) {
      this.timezone = JSON.parse(JSON.stringify(this.initTimezoneData))
      this.timezoneInit = JSON.parse(JSON.stringify(this.initTimezoneData))
    },
    handleTimezoneFormActionCompleted(formAction) {
      this.timezone = JSON.parse(JSON.stringify(this.initTimezoneData))
      this.timezoneInit = JSON.parse(JSON.stringify(this.initTimezoneData))
      this.timezoneFormShow = false
      this.timezoneFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.timezoneFormShow = false
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isTimezoneDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>

<style>
.btn-text {
  color: #2196f3;
}
.btn-text:hover {
  text-decoration: underline;
}
</style>
